import { Routes } from '@angular/router';
import { AppShell } from './layout/app-shell';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
        title: 'menu.dashboard',
      },
      {
        path: 'bookkeeping',
        loadChildren: () => import('./features/bookkeeping/bookkeeping.routes'),
        title: 'menu.bookkeeping',
      },
      {
        path: 'ledger',
        loadChildren: () => import('./features/ledger/ledger.routes'),
        title: 'menu.chartOfAccounts',
      },
      {
        path: 'declarations',
        loadChildren: () => import('./features/declarations/declarations.routes'),
        title: 'menu.declarations',
      },
      {
        path: 'tax-settlements',
        loadComponent: () => import('./features/tax-settlements/tax-settlements').then((m) => m.TaxSettlements),
        title: 'menu.taxSettlements',
      },
      {
        path: 'vehicles',
        loadComponent: () => import('./features/vehicles/vehicles').then((m) => m.Vehicles),
        title: 'menu.vehicles',
      },
      {
        path: 'fixed-assets',
        loadChildren: () => import('./features/fixed-assets/fixed-assets.routes'),
        title: 'menu.fixedAssets',
      },
      {
        path: 'messages',
        loadComponent: () => import('./features/messages/messages').then((m) => m.Messages),
        title: 'menu.messages',
      },
      {
        path: 'comarch',
        loadChildren: () => import('./features/comarch/comarch.routes'),
        title: 'menu.comarchExport',
      },
      {
        path: 'fiscal-reports',
        loadChildren: () => import('./features/fiscal-reports/fiscal-reports.routes'),
        title: 'menu.fiscalReports',
      },
      {
        path: 'samouczek',
        loadComponent: () => import('./features/samouczek/samouczek').then((m) => m.Samouczek),
        title: 'menu.tutorial',
      },
      {
        path: 'time-reports',
        loadComponent: () => import('./features/time-reports/time-reports').then((m) => m.TimeReports),
        title: 'menu.timeReports',
      },
      {
        path: 'zgloszenia',
        loadComponent: () => import('./features/support/support').then((m) => m.Support),
        title: 'menu.support',
      },
    ],
  },
  { path: 'auth', loadChildren: () => import('./features/auth/auth.routes') },
  { path: '**', redirectTo: '' },
];
